import { FunctionComponent } from 'react'
import { DatePickerProps } from './types'

const DatePicker: FunctionComponent<DatePickerProps> = () => null

export { DatePicker }
